import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import useUpdateAttribute from "../../../hooks/variants/attributes/useUpdateAttribute";

const EditAttributeModal = ({ isOpen, onClose, editData = null }) => {
  const [formData, setFormData] = useState({
    attribute_name: editData?.attribute_name || "",
    unit: editData?.unit || "",
    attribute_id: editData?.attribute_id || "",
  });

  const { handleSubmit } = useUpdateAttribute({
    reset: () => {
      setFormData({
        attribute_name: editData?.attribute_name || "",
        unit: editData?.unit || "",
        attribute_id: editData?.attribute_id || "",
      });
      onClose();
    },
  });

  const handleInputChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleSaveAttribute = () => {
    if (!formData.attribute_name.trim()) {
      alert("Please fill in the attribute name");
      return;
    }
    handleSubmit(formData);
  };

  const handleCloseModal = () => {
    setFormData({
      attribute_name: editData?.attribute_name || "",
      unit: editData?.unit || "",
      attribute_id: editData?.attribute_id || "",
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
      <h1 className="text-xl font-semibold text-gray-600 px-4 py-3">
        Edit Attribute
      </h1>
      <DialogContent className="">
        <div className="space-y-4">
          <TextField
            fullWidth
            label="Attribute Name"
            value={formData.attribute_name}
            onChange={handleInputChange("attribute_name")}
            variant="outlined"
            placeholder="Enter attribute name"
          />
          <TextField
            fullWidth
            label="Unit"
            value={formData.unit}
            onChange={handleInputChange("unit")}
            variant="outlined"
            placeholder="Enter unit"
          />
        </div>
      </DialogContent>
      <DialogActions className="p-4 gap-2">
        <Button onClick={handleCloseModal} variant="outlined" color="secondary">
          Back
        </Button>
        <Button
          onClick={handleSaveAttribute}
          variant="contained"
          color="primary"
        >
          Save Attribute
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAttributeModal;
